import { createFileRoute } from "@tanstack/react-router";

import NoPkgs from "~/pages/NoPkgs";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/no-packages")({
  staticData: ROUTE_STATIC.noPackages,
  component: NoPkgs,
});
